import { IPolygonColors } from "../Models/Maps/IPolygonColors";

//Common
export const buxtonLimeGreen = "#1CE180";
export const buxtonNavyBlue = "#2E3D49";

export const topNavHeightPx = 56;

//Mobilytics
export const polygonTooBig = "#FF0000";

export const goodPolygon: IPolygonColors = {
    fillColor: buxtonLimeGreen,
    strokeColor: buxtonNavyBlue
};

export const badPolygon: IPolygonColors = {
    fillColor: polygonTooBig,
    strokeColor: polygonTooBig
};